/**
 * Interactive map block functionality
 */
document.querySelectorAll( '.b-interactive-map' ).forEach( ( block ) => {

	const map = block.querySelector( '.b-interactive-map__map' );
	const mapElements = map.querySelectorAll( '[id]' );
	const defaultColor = '#E7DED3';
	const activeColor = '#CA9272';

	/**
	 * Initialize map by setting default colors
	 */
	const initMap = () => {

		mapElements.forEach( ( element ) => {

			element.style.fill = activeColor;

		} );

	}
	/**
	 * Clear map colors to default
	 */
	const clearMap = () => {

		mapElements.forEach( ( element ) => {

			element.style.fill = defaultColor;

		} );

	}
	/**
	 * Color map item by symbol
	 * @param {string} symbol - The symbol identifier
	 * @param {string} color - The fill color
	 */
	const colorMap = ( symbol, color = defaultColor ) => {


		if ( !symbol ) {

			return;

		}
		const mapItem = map?.querySelector( `#${symbol}` );
		if ( mapItem ) {

			mapItem.style.fill = color;

		}

	};

	/**
	 * Toggle item state
	 * @param {HTMLElement} item - The item element
	 */
	const toggleItem = ( item ) => {

		const isActive = item.classList.contains( 'b-interactive-map-item--active' );
		const symbol = item.dataset.symbol;
		const content = item.querySelector( '.b-interactive-map-item__content' );

		if ( isActive ) {

			item.classList.remove( 'b-interactive-map-item--active' );
			initMap();
			content.style.height = '0px';

		} else {

			// Close all items
			block.querySelectorAll( '.b-interactive-map-item--active' ).forEach( ( el ) => {

				el.classList.remove( 'b-interactive-map-item--active' );
				colorMap( el.dataset.symbol );
				el.querySelector( '.b-interactive-map-item__content' ).style.height = '0px';

			} );

			clearMap();

			// Open clicked item
			const textWrapper = item.querySelector( '.b-interactive-map-item__text-wrapper' );
			const height = textWrapper?.scrollHeight ?? 0;

			item.classList.add( 'b-interactive-map-item--active' );
			colorMap( symbol, activeColor );
			content.style.height = `${height}px`;

		}

	};

	initMap();

	/**
	 * Handle click events using event delegation
	 * @param {Event} e - Click event
	 */
	block.addEventListener( 'click', ( e ) => {

		const item = e.target.closest( '.b-interactive-map-item' );
		if ( item ) {

			toggleItem( item );

		}

	} );

} );